import React from "react";
import "./style.css";
import {
  Popover,
  Card,
  Col,
  Row,
  Steps,
  Collapse,
  Progress,
  Popconfirm,
  Button,
  PageHeader,
  Tag,
  Statistic,
  message,
} from "antd";
import {
  QuestionCircleOutlined,
  FileDoneOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Jumbotron } from "reactstrap";
import { Link } from "react-router-dom";

// import CahmpionsPortal from "../../Images/championsPortal.png";

const { Step } = Steps;
const { Panel } = Collapse;
const { Countdown } = Statistic;
//const deadline = Date.now() + 1000 * 60 * 60 * 24 * 2 + 1000 * 30; // Moment is also OK
const key = "updatable";
class StatusTab extends React.Component {
  state = {
    current: 0,
    currentApplicant: "",

    bio: "",
    hr: "",
    job: "",
    logs: [],
    employeeStatus: "",
    userRole: [],
    lte: "",
    joinedTraining: true,
    showTimer: false,
    trainingDate: null,
  };

  onChange = (current) => {
    console.log("onChange:", current);
    this.setState({ current });
  };

  componentDidMount() {
    const { currentApplicant } = this.props;
    this.setState({ currentApplicant: currentApplicant });
    var joinedTraining = currentApplicant.applicantStatus.phase2.jointTraining;
    console.log(currentApplicant.applicantStatus.phase2.jointTraining);
    this.setState({ joinedTraining: joinedTraining });
    this.showTimer(currentApplicant);
    console.log(window.innerWidth);
  }
  showTimer = (currentApplicant) => {
    let trainingDateTemp = currentApplicant.applicantStatus.phase2.trainingDate;
    let currentDateString = new Date().toLocaleString();
    currentDateString = currentDateString.split(",")[0];
    currentDateString = currentDateString.split("/");
    let formattedCurrentDate =
      currentDateString[2] +
      "-" +
      currentDateString[0] +
      "-" +
      currentDateString[1];
    let trainingDate = trainingDateTemp.split("-");
    formattedCurrentDate = new Date(
      currentDateString[2],
      currentDateString[0] - 1,
      currentDateString[1]
    );
    console.log(
      "Training date: ",
      new Date(trainingDate[0], trainingDate[1] - 1, trainingDate[2])
    );
    console.log(
      "New date: ",
      new Date(
        currentDateString[2],
        currentDateString[0] - 1,
        currentDateString[1]
      )
    );

    if (
      new Date(trainingDate[0], trainingDate[1] - 1, trainingDate[2]) >
      new Date(
        currentDateString[2],
        currentDateString[0] - 1,
        currentDateString[1]
      )
    ) {
      this.setState({
        showTimer: true,
        trainingDate: new Date(
          trainingDate[0],
          trainingDate[1] - 1,
          trainingDate[2]
        ),
      });
    } else {
      this.setState({ showTimer: false });
    }
  };

  joinTraining = () => {
    this.setState({ joinedTraining: true });
    const { currentApplicant } = this.props;
    var tempDate = Date();
    var stringDate = tempDate.toLocaleString();

    message.loading({ content: "Loading...", key });
    //saadsheerazabbasi@gmail.com
    currentApplicant.applicantStatus.phase2.jointTraining = true;

    let object = {
      email: currentApplicant.email,
      password: currentApplicant.password,
      employeeStatus: "Recruited",
      userRole: ["Agent"],
      bio: {
        name: currentApplicant.name,
        cnic: currentApplicant.cnic,
        dob: currentApplicant.dob,
        gender: currentApplicant.gender,
        phone: currentApplicant.phone,
        secondaryPhone: currentApplicant.secondaryPhone,
        email: currentApplicant.email,
        address: currentApplicant.address,
        city: currentApplicant.city,
        provinceRegion: currentApplicant.provinceRegion,
      },
      hr: {
        skypeId: currentApplicant.skypeId,
        netSpeedImage: currentApplicant.netSpeedImage,
        experience: currentApplicant.experience,
        reference: currentApplicant.reference,
        windowsVersion: currentApplicant.windowsVersion,
        prevOrganizations: currentApplicant.prevOrganizations,
        applicantStatus: currentApplicant.applicantStatus,
        recruitStatus: currentApplicant.recruitStatus,
      },
      job: {
        designation: currentApplicant.designation,
        department: currentApplicant.department,
        program: currentApplicant.program,
        salaryType: currentApplicant.salaryType,
        location: currentApplicant.location,
        schedule: currentApplicant.schedule,
        shiftTime: currentApplicant.shiftTime,
        verticle: currentApplicant.verticle,
      },
      lte: { lteCourseCompleted: [] },
      logs: [{ log: "Recruited", by: "System", date: stringDate }],

      nodemailerType: "joinedTraining",
      nodemailerEmail: currentApplicant.email,
      nodemailerName: currentApplicant.name,
      nodemailerDesignation: currentApplicant.designation,
    };

    console.log("training joint: ", object);

    setTimeout(() => {
      fetch(
        "https://work-web-server.herokuapp.com/employees/recruits/register",
        //"http://localhost:5000/employees/recruits/register",
        {
          method: "post",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(object),
        }
      )
        .then((response) => response.json())
        .then((response) => {
          if (response._id) {
            this.setState(
              {
                loader: false,
                editMode: false,
              },
              () => {
                //Update Applicant Status
                let temp = {
                  finalStatus: "Recruited",
                  by: "System",
                  date: stringDate,
                };
                let applicantStatus = currentApplicant.applicantStatus;
                applicantStatus.phase2.jointTraining = true;

                fetch(
                  "https://work-web-server.herokuapp.com/hiring/applicants/edit",
                  //"http://localhost:5000/hiring/applicants/edit",
                  {
                    method: "put",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                      id: currentApplicant._id,
                      recruitStatus: temp,
                      applicantStatus: applicantStatus,
                    }),
                  }
                )
                  .then((response) => response.json())
                  .then((response) => {
                    console.log("setApplicantRecruited: ", response);
                    //this.getApplicants();
                  });

                //Alert Submission
                message.success({
                  content: "Joined Training Successfully!",
                  key,
                  duration: 2,
                });
              }
            );
          } else if (response && !response._id) {
            message.warning({ content: "Error Recruitng !", key, duration: 2 });
            console.log("Error: ", response);
            this.setState({
              loader: false,
              errors: response,
            });
          }
        });
    }, 1000);
  };

  offerStatusUpdate = (status) => {
    console.log("offerStatusUpdate");
    const { currentApplicant } = this.state;
    let myDate = new Date();

    //For Applicant HIRED
    let temp = currentApplicant.applicantStatus;
    temp.offerLetterStatus = {
      issueDate: currentApplicant.applicantStatus.offerLetterStatus.issueDate,
      applicantDate: myDate.toLocaleString(),
      status: status,
    };

    fetch(
      "https://work-web-server.herokuapp.com/hiring/applicants/edit",
      //"http://localhost:5000/hiring/applicants/edit",
      {
        method: "put",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: currentApplicant._id,
          applicantStatus: temp,
          nodemailerType: "offerLetterAccept",
          nodemailerEmail: currentApplicant.email,
          nodemailerName: currentApplicant.name,
          nodemailerDesignation: currentApplicant.designation,
        }),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        console.log("Offer Status Update", response);
        this.componentDidMount();
      });
  };

  render() {
    const { currentApplicant } = this.state;
    var joinedTraining = this.state.joinedTraining;
    const customDot = (dot, { status, index }) => (
      <Popover
        content={
          <span>
            step {index} status: {status}
          </span>
        }
      >
        {dot}
      </Popover>
    );

    //let text = `A dog is a type of domesticated animal.  Known for its loyalty and faithfulness,  it can be found as a welcome guest in many households across the world.`;
    let text = "";

    console.log("Submitted Application: ", currentApplicant);
    if (currentApplicant === "") {
      return <h1>LOADING</h1>;
    } else
      return (
        <div className="statusScreen">
          <Jumbotron className="timelineJumbotron">
            <div>
              <Row className="card">
                <Col>
                  {currentApplicant.recruitStatus.finalStatus ===
                  "Recruited" ? (
                    <Card className="statusCard heartbeat tc" bordered>
                      <h3 className="white">
                        Congrats, you have been hired. Kindly login to champions
                        portal now.
                      </h3>
                      <Button
                        className="blink_me"
                        onClick={() => {
                          localStorage.removeItem("userData");
                          window.open("https://championsportal.netlify.app/");
                        }}
                      >
                        Click to open champions portal
                      </Button>
                    </Card>
                  ) : currentApplicant.applicantStatus.phase1.phaseStatus ===
                      true &&
                    currentApplicant.applicantStatus.offerLetterStatus
                      .status === "Accepted" ? (
                    <Card className="statusCard heartbeat tc" bordered>
                      <h3
                        className={
                          currentApplicant.applicantStatus.batch === ""
                            ? "orange"
                            : "white"
                        }
                      >
                        {currentApplicant.applicantStatus.batch === ""
                          ? "Phase 2 - Batch Assignment Pending"
                          : "Training - Probation beings on " +
                            currentApplicant.applicantStatus.phase2
                              .trainingDate}
                      </h3>
                    </Card>
                  ) : currentApplicant.recruitStatus.finalStatus !==
                    "Recruited" ? (
                    <Card className="statusCard heartbeat tc" bordered>
                      <h3
                        className={
                          currentApplicant.applicantStatus.finalStatus ===
                          "Rejected"
                            ? "red"
                            : currentApplicant.applicantStatus.finalStatus ===
                              "Hired"
                            ? "green"
                            : "white"
                        }
                      >
                        {"Phase 1 - Status: " +
                          currentApplicant.applicantStatus.finalStatus}
                      </h3>
                      {currentApplicant.applicantStatus.finalStatus ===
                        "Hired" &&
                      currentApplicant.applicantStatus.offerLetterStatus
                        .status === "Pending" ? (
                        <h3 className="white">
                          Offer Letter Issued{" "}
                          <FileDoneOutlined
                            title="Logout"
                            style={{ fontSize: "20px" }}
                          />
                          <Popconfirm
                            title="Are you sure you wish to accept this offer？"
                            icon={
                              <QuestionCircleOutlined
                                style={{ color: "green" }}
                              />
                            }
                            // placement="cnter"
                            eslint-disable-next-line
                            onConfirm={() => {
                              this.offerStatusUpdate("Accepted");
                              alert("Thankyou for accepting the offer letter");
                            }}
                            okText="Yes"
                            cancelText="No"
                          >
                            <Button
                              style={{
                                backgroundColor: "green",
                                color: "white",
                              }}
                            >
                              Accept
                            </Button>
                          </Popconfirm>
                          <Popconfirm
                            title="Are you sure you wish to reject this offer？"
                            icon={
                              <QuestionCircleOutlined
                                style={{ color: "red" }}
                              />
                            }
                            // placement="cnter"
                            eslint-disable-next-line
                            onConfirm={() => {
                              this.offerStatusUpdate("Rejected");
                            }}
                            okText="Yes"
                            cancelText="No"
                          >
                            <Button
                              style={{
                                backgroundColor: "red",
                                color: "white",
                              }}
                            >
                              Reject
                            </Button>
                          </Popconfirm>
                        </h3>
                      ) : currentApplicant.applicantStatus.offerLetterStatus
                          .status === "Rejected" ? (
                        <h3 className="red">{"Offer Letter Rejected"} </h3>
                      ) : currentApplicant.applicantStatus.offerLetterStatus
                          .status === "Accepted" ? (
                        <h3 className="green">{"Offer Letter Accepted"} </h3>
                      ) : null}
                    </Card>
                  ) : null}
                </Col>
              </Row>
            </div>

            <div className="tc">
              <br />
              <h3>Applicant Progress</h3>
            </div>

            <div className="container">
              {/*Phase 1*/}
              <PageHeader
                title="Phase 1"
                className="site-page-header"
                // subTitle="This is a subtitle"
                tags={
                  <Tag
                    color={
                      currentApplicant.applicantStatus.phase1.phaseStatus ===
                      true
                        ? "green"
                        : "red"
                    }
                  >
                    {currentApplicant.applicantStatus.phase1.phaseStatus ===
                    true
                      ? "Completed"
                      : "Running"}
                  </Tag>
                }
                avatar={
                  currentApplicant.applicantStatus.finalStatus === "Hired"
                    ? {
                        src: "https://www.clipartmax.com/png/small/12-128569_elegant-clip-art-transparent-background-checkmark-transparent-check-mark-transparent-background.png",
                      }
                    : {
                        src: "https://miro.medium.com/max/1400/1*CsJ05WEGfunYMLGfsT2sXA.gif",
                      }
                }
              />
              <div className="tc  animate__animated animate__fadeInLeft">
                <Steps
                  direction={
                    window.innerWidth < 760 ? "vertical" : "horizontal"
                  }
                  current={
                    currentApplicant.applicantStatus.phase1.currentProgress
                  }
                  progressDot={customDot}
                >
                  <Step
                    title={
                      currentApplicant.applicantStatus.phase1.applied === ""
                        ? "Step 1"
                        : "1. Applied on"
                    }
                    description={
                      currentApplicant.applicantStatus.phase1.applied === ""
                        ? "Pending"
                        : currentApplicant.applicantStatus.phase1.applied
                    }
                  />
                  <Step
                    title={
                      currentApplicant.applicantStatus.phase1.viewed === ""
                        ? "Step 2- Application view status"
                        : "2. Viewed by"
                    }
                    description={
                      currentApplicant.applicantStatus.phase1.viewed === ""
                        ? "Pending"
                        : currentApplicant.applicantStatus.phase1.viewed
                    }
                  />
                  <Step
                    title={
                      currentApplicant.applicantStatus.phase1.contacted
                        .length === 0
                        ? "Step 3- Contact status"
                        : "3. Contacted"
                    }
                    description={
                      currentApplicant.applicantStatus.phase1.contacted
                        .length === 0
                        ? "Pending"
                        : currentApplicant.applicantStatus.phase1.contacted[
                            currentApplicant.applicantStatus.phase1.contacted
                              .length - 1
                          ].date +
                          ", " +
                          currentApplicant.applicantStatus.phase1.contacted[
                            currentApplicant.applicantStatus.phase1.contacted
                              .length - 1
                          ].remarks
                    }
                  />
                  <Step
                    title={
                      currentApplicant.applicantStatus.phase1.resolution === ""
                        ? "Step 4- Resolution"
                        : "4. Resolution"
                    }
                    description={
                      currentApplicant.applicantStatus.offerLetterStatus
                        .status === "Rejected" &&
                      currentApplicant.applicantStatus.phase1.resolution ===
                        "Hired"
                        ? "Offer Letter Rejected by Applicant"
                        : currentApplicant.applicantStatus.phase1.resolution ===
                          "Hired"
                        ? "Hired - Congrats!"
                        : currentApplicant.applicantStatus.phase1.resolution ===
                          "Rejected"
                        ? "Rejected - Sorry!"
                        : "Pending"
                    }
                  />
                </Steps>
              </div>

              {/*Phase 2*/}
              <PageHeader
                title="Phase 2"
                className="site-page-header"
                // subTitle="This is a subtitle"
                tags={
                  <Tag
                    color={
                      currentApplicant.recruitStatus.finalStatus === "Recruited"
                        ? "green"
                        : "red"
                    }
                  >
                    {currentApplicant.applicantStatus.phase2.phaseStatus ===
                    true
                      ? "Completed"
                      : currentApplicant.recruitStatus.finalStatus ===
                        "Recruited"
                      ? "Completed"
                      : currentApplicant.applicantStatus.finalStatus === "Hired"
                      ? "Running"
                      : "Pending"}
                  </Tag>
                }
                avatar={
                  currentApplicant.recruitStatus.finalStatus === "Recruited"
                    ? {
                        src: "https://www.clipartmax.com/png/small/12-128569_elegant-clip-art-transparent-background-checkmark-transparent-check-mark-transparent-background.png",
                      }
                    : {
                        src: "https://miro.medium.com/max/1400/1*CsJ05WEGfunYMLGfsT2sXA.gif",
                      }
                }
              />
              {currentApplicant.applicantStatus.finalStatus === "Rejected" ||
              currentApplicant.applicantStatus.offerLetterStatus.status ===
                "Rejected" ? null : (
                <div className="tc  animate__animated animate__fadeInRight">
                  <Steps
                    direction={
                      window.innerWidth < 760 ? "vertical" : "horizontal"
                    }
                    current={
                      currentApplicant.applicantStatus.phase2.currentProgress
                    }
                    progressDot={customDot}
                  >
                    <Step
                      title={
                        currentApplicant.applicantStatus.offerLetterStatus
                          .status === ""
                          ? "Step 1- Offer Letter"
                          : "1. Offer Letter"
                      }
                      description={
                        currentApplicant.applicantStatus.offerLetterStatus
                          .status === ""
                          ? "Pending"
                          : currentApplicant.applicantStatus.offerLetterStatus
                              .issueDate +
                            ", " +
                            currentApplicant.applicantStatus.offerLetterStatus
                              .status
                      }
                    />
                    <Step
                      title={
                        currentApplicant.applicantStatus.phase2.trainingDate ===
                        ""
                          ? "Step 2- Batch Assignment"
                          : "2. Batch Assigned"
                      }
                      description={
                        currentApplicant.applicantStatus.phase2.trainingDate ===
                        ""
                          ? "Pending"
                          : "Batch number: " +
                            currentApplicant.applicantStatus.batch
                      }
                    />
                    <Step
                      title={
                        currentApplicant.applicantStatus.phase2
                          .trainingSessionLink === ""
                          ? "Step 3- Training"
                          : "3. Training"
                      }
                      description={
                        "Pending"
                        /* !currentApplicant.applicantStatus.batch ? (
                          "Pending"
                        ) : this.state.showTimer ? (
                          <Countdown
                            title="will begin in"
                            value={this.state.trainingDate}
                            format="D H:m:s"
                          />
                        ) : joinedTraining === false ? (
                          <Button
                            onClick={() => {
                              this.joinTraining();
                            }}
                          >
                            Join-Training
                          </Button>
                        ) : (
                          "Training link\n" +
                          currentApplicant.applicantStatus.phase2
                            .trainingSessionLink
                        ) */
                      }
                    />
                  </Steps>
                </div>
              )}
            </div>
            <br></br>
            <div className="tc">
              <h3>General Progress</h3>
            </div>
            <Progress
              strokeColor={{
                from: "#060606",
                to: "#87d068",
              }}
              percent={
                currentApplicant.applicantStatus.finalStatus === "Rejected" ||
                currentApplicant.applicantStatus.offerLetterStatus.status ===
                  "Rejected" ||
                currentApplicant.recruitStatus.finalStatus === "Recruited"
                  ? 100
                  : (
                      ((currentApplicant.applicantStatus.phase1
                        .currentProgress +
                        currentApplicant.applicantStatus.phase2
                          .currentProgress) /
                        7) *
                      100
                    ).toFixed(0)
              }
              status="active"
            />
          </Jumbotron>
        </div>
      );
  }
}

export default StatusTab;
